import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const OPTIONS = [["ask", "Ask me"], ["allow", "Allow"], ["never", "Never"]];

export const usedRecently = (m) => m.last_used_at && Date.now() - new Date(m.last_used_at).getTime() < 7 * 864e5;

export function SensitivePerms({ onChange }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/v2/memory/permissions").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;
  const set = async (k, v) => {
    if (v === "never" && !window.confirm(`Never remember ${d.labels[k].toLowerCase()}? Anything CAMRYN already remembers in this area will be deleted.`)) return;
    try {
      const { data } = await api.put("/v2/memory/permissions", { permissions: { [k]: v } });
      setD(data);
      onChange?.();
      toast.success(`${d.labels[k]}: ${OPTIONS.find((o) => o[0] === v)[1]}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <details className="mt-4 rounded-xl bg-[#F5F2EC] px-4 py-3 group" data-testid="memory-perms">
      <summary className="list-none cursor-pointer flex items-center justify-between text-sm font-semibold text-stone-800" data-testid="memory-perms-toggle">
        Sensitive topics <span className="text-xs font-normal text-stone-500"><span className="group-open:hidden">show</span><span className="hidden group-open:inline">hide</span></span>
      </summary>
      <p className="text-xs text-stone-500 mt-1">Choose what CAMRYN may remember. "Ask me" means nothing here is kept until you tap OK.</p>
      <ul className="mt-2">
        {Object.entries(d.labels).map(([k, label]) => (
          <li key={k} className="flex items-center justify-between gap-3 py-2 border-t border-stone-200/70 first:border-0" data-testid={`memory-perm-${k}`}>
            <span className="text-sm min-w-0">{label}</span>
            <span className="flex shrink-0 rounded-full bg-white p-0.5 border border-stone-200">
              {OPTIONS.map(([v, l]) => (
                <button key={v} type="button" onClick={() => d.permissions[k] !== v && set(k, v)} data-testid={`memory-perm-${k}-${v}`}
                  className={`px-2.5 h-9 rounded-full text-xs font-semibold ${d.permissions[k] === v ? "bg-stone-900 text-white" : "text-stone-600"}`}>{l}</button>
              ))}
            </span>
          </li>
        ))}
      </ul>
    </details>
  );
}
